import { Injectable } from '@angular/core';
import { UserStore } from './user.store';
import { UserQuery } from './user.query';
import { BaseFacade } from '../base/base.facade';
import { UserService } from './user.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';

@Injectable({ providedIn: 'root' })
export class UserFacade extends BaseFacade {
  constructor(
    userService: UserService,
    userStore: UserStore,
    userQuery: UserQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(userService,
      userStore,
      userQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade('users'),
      translateService,
      'users-facade'
      );
  }
}
